<template>
  <div
    class="BundleCover bg-gradient-to-tr from-primary-100 to-tertiary-100 dark:from-primary-darker dark:to-tertiary-darkest relative h-full"
    @mouseenter="onMouseenter" 
    @mouseleave="onMouseleave"
  >
    <img v-if="bundleBg" :src="bundleBg" alt="" class="absolute inset-0" :class="imgCount === 1 ? '' : 'rounded mix-blend-color opacity-70'" />
    <div ref="scrollable"  class="absolute inset-0 overflow-x-scroll rounded flex snap-x snap-mandatory">
      <img v-for="(bundleImg, ndx) in bundleImgs" 
        :src="bundleImg.src" 
        :alt="bundleImg.alt" 
        class="snap-always snap-center object-contain duration-300 shadow-lg relative" 
        :class="showSlider ? 'max-w-full max-h-full rounded' : 'max-w-[50%] max-h-[50%]'" 
        :style="showSlider 
          ? { transform: 'translate(0, 0)' } 
          : { transform: getTransformStyles(ndx) }" 
      />
    </div>
    <div v-if="imgCount && showSlider" class="absolute inset-x-0 bottom-0 pb-gr-5 pt-gr-9 bg-gradient-to-t from-primary-darkest/30 via-primary-darker/10 z-20 flex items-center justify-center">
      <div class="flex items-center justify-center">
        <div v-for="(bundleImg, ndx) in bundleImgs" @click.prevent.stop="activeIndex = ndx" :class="activeIndex == ndx ? 'shadow-xl' : 'bg-opacity-50 hover:bg-opacity-80'" class="duration-250 w-gr-half-6 h-gr-half-6 mx-gr-half-4 bg-white backdrop-blur-lg shadow-sm rounded-full"></div>
      </div>
    </div>
    <div v-if="imgCount && showSlider" class="absolute z-20 top-1/2 -translate-y-1/2 inset-x-gr-3 flex items-center justify-between">
      <button @click.prevent.stop="activeIndex > 0 ? activeIndex-- : null" :class="hasPrev ? 'bg-primary-700/40 hover:bg-primary-700' : 'opacity-0'" class="backdrop-blur duration-250 w-gr-half-8 h-gr-half-8 rounded-full text-center flex items-center justify-center">
        <i class="fa fa-fw fa-chevron-left text-white text-sm"></i>
      </button>
      <button @click.prevent.stop="activeIndex < imgCount ? activeIndex++ : null" :class="hasNext ? 'bg-primary-700/40 hover:bg-primary-700' : 'opacity-0'" class="backdrop-blur duration-250 w-gr-half-8 h-gr-half-8 rounded-full text-center flex items-center justify-center">
        <i class="fa fa-fw fa-chevron-right text-white text-sm"></i>
      </button>
    </div>
    <div
      v-if="!hideCount && bookCount > 1"
      class="absolute z-20 border-gr-1 border-white top-gr-4 left-gr-4 shadow-sm rounded-full bg-primary-darkest text-white text-xs font-bold uppercase leading-[1] px-gr-half-6 py-gr-half-5">
      <span>Get <strong>{{ bookCount }} Titles</strong></span>
    </div>
  </div>
</template>

<script>
  import { isMobile } from '@/Utils/device';
  export default {
    name: 'BundleCover',

    props: {
      book: {
        type: Object,
      },
      spotlight: {
        type: Boolean,
        default: true,
      },
      hideCount: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        activeIndex: 0,
        // slideInterval: null,
        isUpdatingActiveIndex: false,
        showSlider: isMobile(),
      }
    },

    computed: {
      bookCount() {
        return this.book?.bundled_promos?.length;
      },

      imgCount() {
        return this.bundleImgs.length;
      },

      hasNext() {
        return this.activeIndex < this.bundleImgs.length - 1;
      },

      hasPrev() {
        return this.activeIndex > 0;
      },

      bundleImgs() {
        if (this.book?.cover) {
          return [{
            src: `${this.book.cover}?w=400&fm=jpg&q=50`,
            alt: this.book.title,
          }]
        } else if (this.book?.bundled_promos) {
          return this.book.bundled_promos.reduce((arr, bundle) => {
            const cover = bundle?.book?.cover || bundle?.book_cover;
            if (cover) {
              let src = `${cover}?w=400&fm=jpg&q=50`;
              arr.push({
                src,
                alt: bundle?.book?.title,
              });
            }
            return arr;
          }, []);
        }
        return [];
      },

      bundleBg() {
        if (this.book?.cover) {
          return `${this.book.cover}?w=400&fm=jpg&q=50`;
        } else if (this.bookCount) {
          let cover = this.book.bundled_promos.filter(p => {
            return !!p?.book_cover;
          })?.[0]?.book_cover;
          return cover ? `${cover}?w=400&fm=jpg&q=50&blur=100` : null;
        }
        return null;
      },
    },

    mounted() {
      // this.slideInterval = setInterval(() => {
      //   this.activeIndex = (this.activeIndex + 1) % this.bundleImgs.length;
      // }, 3000);

      // update activeIndex on scroll
      this.$refs.scrollable.addEventListener('scroll', () => {
        if (this.isUpdatingActiveIndex) return;
        this.isUpdatingActiveIndex = true;
        let scrollWidth = this.$refs.scrollable.scrollWidth;
        let scrollLeft = this.$refs.scrollable.scrollLeft;
        let activeIndex = Math.round(scrollLeft / scrollWidth * this.bundleImgs.length);
        this.activeIndex = activeIndex;
        this.$nextTick(() => {
          this.isUpdatingActiveIndex = false;
        });
      });

      // setTimeout(() => {
      //   this.showSlider = true;
      // }, 5000);
    },

    beforeDestroy() {
      // clearInterval(this.slideInterval);
      this.$refs.scrollable.removeEventListener('scroll');
    },

    watch: {
      activeIndex(newVal) {
        if (this.isUpdatingActiveIndex) return;
        this.isUpdatingActiveIndex = true;
        let newPosX = this.$refs.scrollable.scrollWidth * newVal / this.bundleImgs.length;
        this.$refs.scrollable.scrollTo({
          left: newPosX,
          behavior: 'smooth',
        });
        this.$nextTick(() => {
          this.isUpdatingActiveIndex = false;
        });
      },

      showSlider(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$refs.scrollable.scrollTo({
            left: 0,
            behavior: 'smooth',
          });
        }
      },
    },

    methods: {
      setActiveIndex(index) {
        this.activeIndex = index;
      },

      onMouseenter() {
        this.showSlider = true;
      },

      onMouseleave() {
        this.showSlider = isMobile();
      },

      getTransformStyles(ndx) {
        let translateX = `translate(${100 - 100 * ndx - (100 / (this.imgCount - 1)) * (this.imgCount - 1 - ndx)}%, ${100 / (this.imgCount - 1) * (this.imgCount - 1 - ndx)}%)`;
        if (this.imgCount > 2 && this.imgCount < 5) {
          if (ndx === 0) translateX = `translate(0, 0)`;
          if (ndx === 1) translateX = `translate(-100%, 100%)`;
          if (ndx === 2) translateX = `translate(-100%, 0%)`;
          if (ndx === 3) translateX = `translate(-200%, 100%)`;
        }
        return translateX;
      },
    },
  };
</script>

<!-- <style lang="scss" src="./BundleCover.scss" scoped></style> -->
